import React from 'react';
import { Desktop, MobileAndTablet } from '@stockx/ui';
import {
  StyledModalImageContainer,
  StyledModalImageLabel,
  StyledModalImageContainerStyles,
  StyledModalImageLabelText,
} from './UserGeneratedContentModal.styles';

const UserGeneratedContentImageLabel = ({ creator }) => (
  <>
    <Desktop>
      <StyledModalImageContainer
        test-id="UserGeneratedContentModalImageContainer"
        sx={StyledModalImageContainerStyles.variants['desktop']}
      >
        <StyledModalImageLabel>
          <StyledModalImageLabelText sx={{ transform: 'rotate(90deg)' }}>
            📸:
          </StyledModalImageLabelText>
          <StyledModalImageLabelText sx={{ writingMode: 'vertical-rl' }}>
            {' '}
            {creator}
          </StyledModalImageLabelText>
        </StyledModalImageLabel>
      </StyledModalImageContainer>
    </Desktop>
    <MobileAndTablet>
      <StyledModalImageContainer
        test-id="UserGeneratedContentModalImageContainer"
        sx={StyledModalImageContainerStyles.variants['mobile']}
      >
        <StyledModalImageLabel>
          <StyledModalImageLabelText>📸: {creator}</StyledModalImageLabelText>
        </StyledModalImageLabel>
      </StyledModalImageContainer>
    </MobileAndTablet>
  </>
);

export default UserGeneratedContentImageLabel;
